var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4773 6.09269C1.13935 6.43064 0.591419 6.43064 0.253465 6.09269C-0.0844885 5.75473 -0.0844884 5.2068 0.253465 4.86885L4.86885 0.253465C5.20681 -0.0844885 5.75474 -0.0844884 6.09269 0.253465L10.7081 4.86885C11.046 5.2068 11.046 5.75474 10.7081 6.09269C10.3701 6.43064 9.82219 6.43064 9.48424 6.09269L6.34616 2.95461L6.34616 14.1346C6.34616 14.6126 5.95871 15 5.48077 15C5.00283 15 4.61539 14.6126 4.61539 14.1346L4.61539 2.95461L1.4773 6.09269Z",
    fill: "#0FAF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.48482cbe128ecbf43c400b45d6622d5b.svg";
export { ForwardRef as ReactComponent };